import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'

export type InputProps = {
  company: string
  companyType: string
  street: string
  zipCode: string
  city: string
  country: string
  webAdress?: string
  employeeCount: number
  sex: string
  firstname: string
  lastname: string
  phone: string
  fax?: string
  email: string
  termsOfUse?: boolean
  newsletter?: boolean
  dealer?: string
}

export type Variables = {
  company: string
  companyType: string
  street: string
  zipCode: string
  city: string
  country: string
  webAdress?: string
  employeeCount: number
  sex: string
  firstname: string
  lastname: string
  phone: string
  fax?: string
  email: string
  termsOfUse?: boolean
  newsletter?: boolean
  dealer?: string
}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

const USER_DATA_MUTATION = gql`
  mutation setUserData(
    $company: String!
    $companyType: String!
    $street: String!
    $zipCode: String!
    $city: String!
    $country: String!
    $webAdress: String
    $employeeCount: Float
    $sex: String!
    $firstname: String!
    $lastname: String!
    $phone: String!
    $fax: String
    $email: String!
    $termsOfUse: Boolean
    $newsletter: Boolean
    $dealer: String
  ) {
    setUserData(
      company: $company
      companyType: $companyType
      street: $street
      zipCode: $zipCode
      city: $city
      country: $country
      webAdress: $webAdress
      employeeCount: $employeeCount
      sex: $sex
      firstname: $firstname
      lastname: $lastname
      phone: $phone
      fax: $fax
      email: $email
      termsOfUse: $termsOfUse
      newsletter: $newsletter
      dealer: $dealer
    )
  }
`

export const USER_DATA_QUERY = gql`
  query {
    getUserData {
      company
      companyType
      street
      zipCode
      city
      country
      webAdress
      employeeCount
      sex
      firstname
      lastname
      phone
      fax
      email
      dealer
    }
  }
`

const withUserDataMutation = graphql<InputProps, Response, Variables, ChildProps>(
  USER_DATA_MUTATION,
)

export default withUserDataMutation
